<div class="d-flex justify-content-center mt-3">
    <ws-ace-card header="Change Password" width="450px">
        <ng-container card-body>
            <form name="form" class="form-horizontal">
                <new-password [showCurrent]="true"
                              [(passwords)]="password"
                              [(passwordsValid)]="passwordsValid"
                              [alreadyUsed]="alreadyUsed">
                </new-password>
                <div class="mb-4">
                    <div class="d-flex justify-content-center">
                        <button type="submit"
                                class="ace-btn btn-primary"
                                title="Change"
                                (click)="changePassword()"
                                [disabled]="!passwordsValid || disableSave">
                            Save
                        </button>
                        <button type="button"
                                class="ace-btn btn-secondary ms-1"
                                title="Cancel"
                                (click)="goToHome()">
                            Cancel
                        </button>
                    </div>
                </div>
            </form>
        </ng-container>
    </ws-ace-card>
</div>
